import { html } from 'lit-element';
import { ifNotNull } from '../../utils/directives';
import { KatalComponent, KatLitElement } from '../../shared/base';

/**
 * @component {kat-link} KatalLink Link to a different page
 * @example Amazon.com {"label": "Amazon", "href":"https://www.amazon.com", "variant":"link"}
 * @example LinkAsButton {"label": "Amazon", "href":"https://www.amazon.com", "variant":"button"}
 * @status Production
 */
class KatalLink extends KatLitElement {
  static get properties() {
    return {
      /**
       * @classprop {string} label The text to display for the link
       */
      label: { type: String, reflect: true },

      /**
       * @classprop {string} href The location to navigate to
       */
      href: { type: String, reflect: true },

      /**
       * @classprop {enum} target Specifes how to open the link
       * @enum {value} _blank Opens in a new window
       */
      target: { type: String, reflect: true },

      /**
       * @classprop {enum} variant Sets the visual variant of the link
       * @enum {value} link Displays as a traditional link - Default
       * @enum {value} button Displays the link as a button link
       */
      variant: { type: String, reflect: true },

      /**
       * @classprop {string} download If the attribute has a value, it is used as the pre-filled file name
       * in the Save prompt (the user can still change the file name if they want).
       */
      download: { type: String, reflect: true },
    };
  }

  constructor() {
    super();
    this.variant = 'link';
  }

  // disable shadow-dom
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <a
        href=${ifNotNull(this.href)}
        target=${ifNotNull(this.target)}
        download=${ifNotNull(this.download)}
      >
        ${this.label}
      </a>
    `;
  }
}

KatalComponent.register('kat-link', KatalLink);
